module.exports = __webpack_public_path__ + "img/shopping-bag.b6197a3e.svg";